import { render, staticRenderFns } from "./general-z-report.vue?vue&type=template&id=0f22a488"
import script from "./general-z-report.vue?vue&type=script&lang=js"
export * from "./general-z-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports